import React from "react"

const DisplayContext = React.createContext({})

export const DisplayProvider = DisplayContext.Provider
export const DisplayConsumer = DisplayContext.Consumer

export default DisplayContext
